import { useNavigationManager, useLocation } from '@provider/navigation';
import { useComponentEntry } from '@utils/component-framework';
import { useChangeEffect } from '@utils/react';

function useCurrentTask(componentData, entryKey) {
  const navigationManager = useNavigationManager();
  const location = useLocation();
  const entryTaskId = useComponentEntry(entryKey, {
    select: entry => entry?.data.currentTaskId
  });
  useChangeEffect(() => {
    navigationManager.push("/");
  }, [entryKey]);
  const pathnameSegments = location.pathname.split("/");
  const locationTaskId = location.searchParams.get("taskId") || pathnameSegments[pathnameSegments.length - 1];

  // We prefer to fetch the current task based on the provided location...
  let currentTaskIndex = componentData.tasks.findIndex(it => it.id === locationTaskId);

  // ... however, if there's no matches, then fall back to the current task
  // for the provided entry, if any.
  if (currentTaskIndex === -1 && entryTaskId.data) {
    currentTaskIndex = componentData.tasks.findIndex(it => it.id === entryTaskId.data);
  }
  if (currentTaskIndex === -1) {
    currentTaskIndex = 0;
  }
  return {
    task: componentData.tasks[currentTaskIndex],
    index: currentTaskIndex
  };
}

export { useCurrentTask };
//# sourceMappingURL=util.get-current-task.js.map
